import React from 'react';
import styled from 'styled-components';
import PremiumLicenseForm from './Form';
import PremiumLicenseList from './List';

interface LicenseGroup {
  role: string;
  licenseNumbers: {
    license: string;
    isRegistered: boolean;
    hasValidRole?: boolean;
    createdAt?: string;
  }[];
  count: number;
}

interface PremiumLicensesTemplateProps {
  /** Form Props */
  selectedRole: string;
  licenseNumbers: string;
  onRoleChange: (role: string) => void;
  onLicenseNumbersChange: (value: string) => void;
  onAdd: () => void;
  onDelete: () => void;

  /** List Props */
  licenses: LicenseGroup[];
  onDeleteRole: (role: string, licenseNumbers: string[]) => void;
  onDeleteLicense: (role: string, license: string) => void;
  onGrantRole: (role: string, license: string) => void;
  onExportAll: () => void;
  onExportRegion: (group: LicenseGroup) => void;

  /** Common */
  isLoading?: boolean;
}

const PremiumLicensesTemplate: React.FC<PremiumLicensesTemplateProps> = ({
  selectedRole,
  licenseNumbers,
  onRoleChange,
  onLicenseNumbersChange,
  onAdd,
  onDelete,
  licenses,
  onDeleteRole,
  onDeleteLicense,
  onGrantRole,
  onExportAll,
  onExportRegion,
  isLoading = false,
}) => {
  return (
    <Container>
      <FormSection>
        <PremiumLicenseForm
          selectedRole={selectedRole}
          licenseNumbers={licenseNumbers}
          onRoleChange={onRoleChange}
          onLicenseNumbersChange={onLicenseNumbersChange}
          onAdd={onAdd}
          onDelete={onDelete}
          isLoading={isLoading}
        />
      </FormSection>

      <Divider />

      <ListSection>
        <PremiumLicenseList
          licenses={licenses}
          onDeleteRole={onDeleteRole}
          onDeleteLicense={onDeleteLicense}
          onGrantRole={onGrantRole}
          onExportAll={onExportAll}
          onExportRegion={onExportRegion}
          isLoading={isLoading}
        />
      </ListSection>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  padding: 24px;
  max-width: 1200px;
  margin: 0 auto;
`;

const FormSection = styled.section`
  width: 100%;
`;

const ListSection = styled.section`
  width: 100%;
`;

const Divider = styled.hr`
  border: none;
  border-top: 1px solid #e0e0e0;
  margin: 0;
`;

export default PremiumLicensesTemplate;
